// import ModuleService from '@/services/module';
// import useSessionStore from '@/stores/session';
// import Logger from '@/utils/logger';
import RouterUtils from '@/utils/router';
import ModuleParticipation from '@/views/ModuleParticipation.vue';

export default [
  {
    path: '/participation',
    name: 'moduleParticipation',
    component: ModuleParticipation,
    beforeEnter: [RouterUtils.checkLoginUser, RouterUtils.resetHUBSettings, RouterUtils.checkRunningModule],
    props: true,
  },
];
